import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const SET_AUTO_TUNER_BY_1801_CPU_ID = gql`
mutation SetAutoTunerBy1801CpuId($domain: String!, $cpuId: String!, $port: Int!, $value: Int!) {
	device {
		setAutoTunerBy1801CpuId(domain: $domain, cpuId: $cpuId, port: $port, value: $value) {
			code
			success
			message
		}
	}
}
`

export interface SetAutoTunerBy1801CpuIdResponse {
	device: {
		setAutoTunerBy1801CpuId: Def_MutationResponse
	}
}

export interface SetAutoTunerBy1801CpuIdArgs {
	domain: string;
	cpuId: string;
	port: number;
	value: number;
}

